import Box from '@mui/material/Box';
import EmptyStateWithButton from '../../../common/empty-state/EmptyStateWithButton';
import AiEmptyStateImg from './aiEmptyState.svg?react';
import { Permission } from '@server/permissions';

interface AiAssistantEmptyStateProps {
  setAiAssistantDialogOpen: (open: boolean) => void;
  permissionString: Permission[];
}

export const AiAssistantEmptyState = ({
  setAiAssistantDialogOpen,
  permissionString,
}: AiAssistantEmptyStateProps) => {
  return (
    <Box sx={{ pt: '6vh', maxWidth: '610px', m: '0 auto', textAlign: 'center' }}>
      <EmptyStateWithButton
        image={<AiEmptyStateImg />}
        line1=""
        line2="Add our Support AI Assistant to Salesforce and empower users to solve issues on their own. Once installed, all of the Assistant's conversations will appear here for your review."
        onClick={() => setAiAssistantDialogOpen(true)}
        permissionString={permissionString}
        notAllowedTitle={'To add support AI, please contact your admin.'}
      />
    </Box>
  );
};
